// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SearchBar-cls1___af951daf7314fc2263d{/*!*/}.SearchBar-cls2__ca507b5371ffc77f9fda{width:12px;vertical-align:baseline;filter:invert(37%) sepia(100%) saturate(7500%) hue-rotate(215deg) brightness(91%) contrast(93%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SearchBar-cls1___af951daf7314fc2263d",
	"cls2": "SearchBar-cls2__ca507b5371ffc77f9fda SearchBar-cls1___af951daf7314fc2263d"
};
export default ___CSS_LOADER_EXPORT___;
